import * as React from "react";
const SvgExclude = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3H16V8H21V21H8V16H3V3ZM15 9H9V15H15V9Z", fill: "currentColor" }));
export default SvgExclude;
